<template>
    <div class="article-box">
        <div class="left-box">
            <div class="white-bg">
                <div class="news-title"><span class="weizhi">您现在的位置是：<router-link to="" >首页</router-link>&nbsp;>&nbsp;<router-link to="" 
                        >视频教程</router-link>&nbsp;>&nbsp;<router-link to="" >前端设计</router-link></span>
                    <h2>前端设计</h2>
                </div>
                <div class="news-text-box">
                    <h1 class="news-title-h1">帝国cms视频教程——第二课，程序安装（云服务器搭建环境）金牛云服为例</h1>
                    <div class="keywords"></div>
                    <div class="pic-view-other"><span class="po-date">2019-05-08</span><span
                            class="po-classname">前端设计</span><span class="po-view"></span>
                    </div>
                    <div class="small-text"><i></i>建站需要购买云服务器还是虚拟主机，如果是同样的价格，我肯定会选云服务器，如果你不介意他是一家新的空间商，可以购买我推荐的，金牛云服，新账号购买，只需要8.8一个月。
                    </div>
                    <div class="news-text">
                        <video controls="controls" height="auto" id="ecmsvideoid" playsinline="" webkit-playsinline=""
                               width="100%" x-webkit-airplay="allow" x5-playsinline="">&gt;<source
                                src="https://www.yangqq.com/d/file/jstt/ecms/2018-11-25/ba53039c5f6112c9099dcefaab270d91.mp4"/>
                            Your browser is not supported
                        </video>
                        <p></p>
                    </div>
                    <div class="diggit"><router-link to="" 
                            >
                        很赞哦！ </router-link>(<b id="diggnum">

                    </b>)
                    </div>
                    <div class="clear"></div>
                    <div class="share" id="down"><img src="../../assets/images/wx.jpg">
                        <div class="share-text">
                            <p>扫描关注青于蓝微信公众号，第一时间获取网站模板更新动态</p>
                            <p>转载请说明来源于"青于蓝排名建站"</p>
                            <p>本文地址：<router-link to=""  >/course/web/79.html</router-link></p>
                        </div>
                    </div>
                    <div class="clear"></div>
                    <div class="info-pre-next">
                        <ul>
                            <li><router-link to="" ><i><em>上一篇</em><img src="../../assets/images/pic04.jpg"></i>
                                <h2>帝国cms视频教程——第一课，程序安装（虚拟主机安装）金牛云服为例</h2>
                                <p>
                                    《帝国网站管理系统》英文译为＂EmpireCMS＂，它是基于B/S结构，安全、稳定、强大、灵活的网站管理系统．我入行快十年了，从第二个年头起，我就一直用的是帝国cms建站。十年，以后也不止是十年，经历了那么多次的改版，每一次改版都带来惊喜，给用户更好的体验。网上有关帝国cms视频教程，确实是很少，在这里，我将把自己多年来建站的经验，以及使用帝国cms的一些技巧，都教给大家。
                                </p>
                            </router-link></li>
                            <li><router-link to="" ><i><em>下一篇</em><img src="../../assets/images/pic02.jpg"></i>
                                <h2>个人博客模板《今夕何夕》后台管理文档-在线视频教程</h2>
                                <p>购买了《今夕何夕》安装服务费的，可以参考今夕何夕的后台管理文档和视频，十几分钟的视频讲解再加上文档，可以帮助你很快的熟悉后台，并且掌握方法，尽快使用上。</p>
                            </router-link></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="clear blank"></div>
            <div class="other-link white-bg">
                <div class="news-title">
                    <h2>相关文章</h2>
                </div>
                <ul>
                    <li><router-link to=""  title="个人博客模板《今夕何夕》后台管理文档-在线视频教程">个人博客模板《今夕何夕》后台管理文档-在线视频教程</router-link></li>
                    <li><router-link to=""  title="帝国cms视频教程——第二课，程序安装（云服务器搭建环境）金牛云服为例">帝国cms视频教程——第二课，程序安装（云服务器搭建环境）金牛云服为例</router-link>
                    </li>
                    <li><router-link to="" 
                           title="帝国cms视频教程——第一课，程序安装（虚拟主机安装）金牛云服为例">帝国cms视频教程——第一课，程序安装（虚拟主机安装）金牛云服为例</router-link></li>
                    <li><router-link to=""  title="十条设计原则教你学会如何设计网页布局!">十条设计原则教你学会如何设计网页布局!</router-link></li>
                    <li><router-link to=""  title="别让这些闹心的套路，毁了你的网页设计">别让这些闹心的套路，毁了你的网页设计</router-link></li>
                    <li><router-link to=""  title="网页中图片属性固定宽度，如何用js改变大小">网页中图片属性固定宽度，如何用js改变大小</router-link></li>
                    <li><router-link to=""  title="企业网站建设前期，公司该做什么样的网站？要看企业如何定位自身">企业网站建设前期，公司该做什么样的网站？要看企业如何定位自身</router-link></li>
                    <li><router-link to=""  title="个人博客网站用帝国cms如何添加音乐">个人博客网站用帝国cms如何添加音乐</router-link></li>
                </ul>
            </div>
            <div class="ad ad-big"><router-link to=""  target=_blank><img
                    src='http://menhu.yangqq.com/d/file/p/2019/05-11/82c0a8be75a4fa8d152cae2cdc05d1c4.jpg' border=0
                    width='830' height='140' alt=''></router-link></div>
            <div class="pinglun-box white-bg">
                <div class="news-title">
                    <h2>文章评论</h2>
                </div>
                <!-- 评论 开始 -->
                <div class="pinglun">
                    <div class="pl-520am" data-id="79" data-classid="16" data-showhot="0"></div>

                </div>
                <!-- 评论 结束 -->
            </div>
        </div>
        <aside class="side-section right-box">
            <div class="side-tab">
                <ul class="side-tab-ul">
                    <li class="sidetab-current">站长推荐</li>
                    <li>点击排行</li>
                </ul>
                <div id="sidetab-content">
                    <section>
                        <div class="rec">
                            <section class="top-news img-scale"><router-link to="" ><img
                                    src="../../assets/images/pic02.jpg"><span>个人博客模板《今夕何夕》后台管理文档-在线视频教程</span></router-link>
                            </section>
                            <ul>
                                <li><router-link to=""  title="帝国cms视频教程——第二课，程序安装（云服务器搭建环境）金牛云服为例"
                                       ><i><img src="../../assets/images/pic03.jpg"></i>
                                    <p>帝国cms视频教程——第二课，程序安装（云服务器搭建环境）金牛云服为例</p>
                                </router-link></li>
                                <li><router-link to=""  title="帝国cms视频教程——第一课，程序安装（虚拟主机安装）金牛云服为例" ><i><img
                                        src="../../assets/images/pic04.jpg"></i>
                                    <p>帝国cms视频教程——第一课，程序安装（虚拟主机安装）金牛云服为例</p>
                                </router-link></li>
                            </ul>
                        </div>
                    </section>
                    <section>
                        <div class="sort-box">
                            <section class="top-news img-scale"><router-link to="" ><img
                                    src="../../assets/images/pic02.jpg"><span>个人博客模板《今夕何夕》后台管理文档-在线视频教程</span></router-link>
                            </section>
                            <ul>
                                <li><i></i><router-link to=""  title="个人博客模板《今夕何夕》后台管理文档-在线视频教程" >个人博客模板《今夕何夕》后台管理文档-在线视频教程</router-link>
                                </li>
                                <li><i></i><router-link to=""  title="帝国cms视频教程——第一课，程序安装（虚拟主机安装）金牛云服为例" >帝国cms视频教程——第一课，程序安装（虚拟主机安装）金牛云服为例</router-link>
                                </li>
                                <li><i></i><router-link to=""  title="帝国cms视频教程——第二课，程序安装（云服务器搭建环境）金牛云服为例"
                                              >帝国cms视频教程——第二课，程序安装（云服务器搭建环境）金牛云服为例</router-link></li>
                                <li><i></i><router-link to=""  title="网页中图片属性固定宽度，如何用js改变大小" >网页中图片属性固定宽度，如何用js改变大小</router-link>
                                </li>
                                <li><i></i><router-link to=""  title="个人博客网站用帝国cms如何添加音乐" >个人博客网站用帝国cms如何添加音乐</router-link>
                                </li>
                                <li><i></i><router-link to=""  title="企业网站建设前期，公司该做什么样的网站？要看企业如何定位自身" >企业网站建设前期，公司该做什么样的网站？要看企业如何定位自身</router-link>
                                </li>
                                <li><i></i><router-link to=""  title="别让这些闹心的套路，毁了你的网页设计" >别让这些闹心的套路，毁了你的网页设计</router-link>
                                </li>
                                <li><i></i><router-link to=""  title="十条设计原则教你学会如何设计网页布局!" >十条设计原则教你学会如何设计网页布局!</router-link>
                                </li>
                            </ul>
                        </div>
                    </section>
                </div>
            </div>
            <div class="ad ad-small"><router-link to="" 
                                        target=_blank><img
                    src='http://menhu.yangqq.com/d/file/p/2019/05-11/d27278b3e3d7e3dabf07fcee6fc54dc1.jpg' border=0
                    width='320' height='132' alt=''></router-link></div>
            <div class="white-bg cloud">
                <h2 class="side-title">标签云</h2>
                <ul>
                    <router-link to=""  >帝国cms(1)</router-link> <router-link to="" 
                         >后台管理文档(1)</router-link> <router-link to="" 
                         >遇见(1)</router-link> <router-link to="" 
                         >2(1)</router-link> <router-link to="" 
                         >评论插件(1)</router-link> <router-link to="" 
                         >心灵鸡汤(1)</router-link> <router-link to="" 
                         >SEO(1)</router-link> <router-link to="" 
                         >匆匆4年(1)</router-link> <router-link to="" 
                         >坚定信念(1)</router-link> <router-link to="" 
                         >音乐(1)</router-link> <router-link to="" 
                         >运营(1)</router-link> <router-link to="" 
                         >付出才有收获(1)</router-link> <router-link to="" 
                         >程序源码(1)</router-link> <router-link to="" 
                         >雨天(1)</router-link> <router-link to="" 
                         >网页设计(1)</router-link> <router-link to="" 
                         >北大青鸟(1)</router-link> <router-link to="" 
                         >职业生涯(1)</router-link> <router-link to="" 
                         >设计师(1)</router-link> <router-link to="" 
                         >个人博客(5)</router-link> <router-link to="" 
                         >seo优化(1)</router-link></ul>
            </div>
            <div class="clear blank"></div>
            <div class="white-bg auto">
                <h2 class="side-title">猜你喜欢</h2>
                <ul>
                    <li><router-link to=""  >别让这些闹心的套路，毁了你的网页设计</router-link></li>
                    <li><router-link to=""  >企业网站建设前期，公司该做什么样的网站？要看企业如何定位自身</router-link></li>
                    <li><router-link to=""  >帝国cms视频教程——第一课，程序安装（虚拟主机安装）金牛云服为例</router-link></li>
                    <li><router-link to=""  >十条设计原则教你学会如何设计网页布局!</router-link></li>
                    <li><router-link to=""  >个人博客网站用帝国cms如何添加音乐</router-link></li>
                    <li><router-link to=""  >帝国cms视频教程——第二课，程序安装（云服务器搭建环境）金牛云服为例</router-link></li>
                    <li><router-link to=""  >个人博客模板《今夕何夕》后台管理文档-在线视频教程</router-link></li>
                    <li><router-link to=""  >网页中图片属性固定宽度，如何用js改变大小</router-link></li>
                </ul>
            </div>
        </aside>
    </div>
</template>

<script>
    export default {
        name: "Play"
    }
</script>

<style scoped>

</style>